exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bibleCloudSearch-title[data-v-caccf4fa] {\n  font-family: \"Baskervville\", serif !important;\n  font-size: 34px;\n  padding: 20px 0;\n  text-align: center;\n}\n.bibleCloudSearch-title-query[data-v-caccf4fa] {\n  font-family: \"Open Sans\", sans-serif !important;\n}\n.bibleCloudSearch-result[data-v-caccf4fa] {\n  border-bottom: 1px solid #ccced0;\n  padding-bottom: 10px;\n  margin-bottom: 28px;\n}\n.bibleCloudSearch-result-title[data-v-caccf4fa] {\n  font-size: 20px;\n  font-weight: 600;\n}\n.bibleCloudSearch-result-title-abbreviation[data-v-caccf4fa] {\n  color: #616b7d;\n}", ""]);

// exports
